import {
  Dialog,
  paperClasses,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { BetweenLayout } from './BetweenLayout';
import { CloseButtonContainer, ModalCloseButton } from './ModalCloseButton';
import { HscanTable, HscanTableCell } from './SortableTable/Table';
import { Spacer } from './Spacer';
import { CurrentTimeText } from './styledComponents';

const StyledDialog = styled(Dialog)`
  & .${paperClasses.root} {
    max-width: 1125px;
    max-height: 410px;
    min-height: fit-content;
    width: 100%;

    ${p => p.theme.isMobile && 'margin: 4px;'}
  }
`;

const StyledContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  max-width: calc(100% - 2px);
  box-sizing: border-box;
  padding: 1em;
`;

export interface HistoryTableRow {
  createdAt: string;
  content: string;
}

interface HistoryTableModalProps {
  open: boolean;
  onClose?: (open: boolean) => void;
  rows: HistoryTableRow[];
}
export const HistoryTableModal = (props: HistoryTableModalProps) => {
  const { open, onClose, rows } = props;
  const { t } = useTranslation();

  return (
    <StyledDialog onClose={onClose} open={open}>
      <StyledContainer>
        <CloseButtonContainer>
          <ModalCloseButton onClick={() => onClose?.(true)} />
        </CloseButtonContainer>
        <Spacer height="15px" />
        <BetweenLayout
          right={
            <CurrentTimeText>
              {moment().format(`${t('currentTime')}`)}
            </CurrentTimeText>
          }
        />
        <Spacer height="13px" />
        <HscanTable
          head={
            <TableHead>
              <TableRow>
                <HscanTableCell
                  width="fit-content"
                  align="center"
                  $border="1px solid">{`${t(
                  'historyTable.header.date',
                )}`}</HscanTableCell>
                <HscanTableCell align="justify">{`${t(
                  'historyTable.header.details',
                )}`}</HscanTableCell>
              </TableRow>
            </TableHead>
          }
          body={
            <TableBody>
              {!!rows.length &&
                rows.map((history, idx) => (
                  <TableRow key={idx}>
                    <HscanTableCell align="center" $border="1px solid">
                      {moment(history.createdAt).format('YYYY.MM.DD HH:mm:ss')}
                    </HscanTableCell>
                    <HscanTableCell align="justify">
                      {history.content}
                    </HscanTableCell>
                  </TableRow>
                ))}
            </TableBody>
          }
        />
      </StyledContainer>
    </StyledDialog>
  );
};
